<template>
  <div class="login fs-34 c-152338">
    <div class="hintText1">Hello！</div>
    <div class="hintText2">{{ $t("login.loginHint") }}</div>

    <div class="position-r">
      <img src="../../assets/login/slope_bg.png" class="slope" />
      <div class="loginContent">
        <!-- 账号 -->
        <div class="labelTitle">{{ $t("login.account") }}</div>
        <input @keydown="onKeydown($event)" maxlength="50" v-model="model.userName"
          :placeholder="$t('login.accountHint')" autocomplete="username" class="loginInput" />
        <!-- 密码 -->
        <div class="labelTitle mt-48">{{ $t("login.password") }}</div>
        <input @keydown="onKeydown($event)" maxlength="15" v-model="model.passWord" type="password"
          :placeholder="$t('login.passwordHint')" autocomplete="current-password" class="loginInput" />
        <!-- 登录 -->
        <div @click="onClickLogin()" class="pageOperationBtn bc-3143C4" style="margin-top: 4.8rem;">{{ $t('login.login')
          }}</div>
      </div>
      <img src="../../assets/login/people_icon.png" class="loginIcon" />
    </div>
    <div class="agreement">
      <van-checkbox v-model="checkAgreement" checked-color="#3143C4"></van-checkbox>
      <div class="flex-grow-1 ml-20">
        <span>{{ $t("login.agreementHint") }}</span>
        <span @click="onClickServiceAgreement()" class="c-3143C4">《{{ $t("login.serviceAgreement") }}》</span>
        <span @click="onClickPrivacyAgreement()" class="c-3143C4">《{{ $t("login.privacyAgreement") }}》</span>
        <span @click="onClickChildProtection()" class="c-3143C4">《{{ $t("login.childProtection") }}》</span>
      </div>
    </div>
  </div>
</template>

<script>
import '@/style/login/login.scss';

export default {
  name: 'login',
  data() {
    return {
      tenantId: "",
      tenantName: "",
      model: {
        userName: "", //账号
        passWord: "" //密码
      },
      checkAgreement: false
    }
  },
  created() {
    this.mergeLang("login");

    this.tenantId = this.$route.query.tenantId || this.$route.query.tenantID || this.$route.query.tenantid;
    if (!this.tenantId) {
      this.tenantId = localStorage.getItem("defaultTenantId");
    }
    if (!this.tenantId) {
      this.tenantId = "999";
    }
    this.getTenantInfo();
  },
  mounted() {},
  methods: {
    // 查询租户名称
    getTenantInfo() {
      let params = {
        url: this.$request.url.login.getTenantInfo + "/" + this.tenantId,
        data: {},
        headers: {
          tenantId: this.tenantId,
        }
      }
      let that = this;
      this.$request.get(params, function (type, response) {
        if (type == 0) {
          that.tenantName = response.data.tenantName;
        }
      });
    },
    /**
     * 监听键盘按键
     * @param {Object} event
     */
    onKeydown(event) {
      if (event.keyCode == 13) {
        this.onClickLogin();
      }
    },

    /**
     * 登录
     */
    onClickLogin() {
      if (this.model.userName.trim() == "") {
        this.$toast(this.$t('login.accountHint'));
        return;
      }
      if (this.model.passWord == "") {
        this.$toast(this.$t('login.passwordHint'));
        return;
      }
      if (!this.checkAgreement) {
        this.$toast(this.$t('login.userPrivacyPolicyHint'));
        return;
      }
      this.passWordLogin();
    },
    passWordLogin() {
      let params = {
        url: this.$request.url.login.login,
        data: {
          username: this.model.userName,
          password: this.model.passWord
        },
        headers: {
          tenantId: this.tenantId
        }
      }
      this.$toast.loading({
        message: this.$t("common.loading"),
        forbidClick: true,
        duration: 0
      });
      this.$request.post(params, (type, response) => {
        this.$toast.clear();
        if (type == 0) {
          const data = response.data;
          const userInfo = data.sysUser;
          const token = data.token;
          userInfo.token = token;
          // 保存用户信息
          this.$utils.setUserInfo(userInfo);
          const return_url = this.$route.query.return_url;
          if (return_url) {
            window.location.replace(decodeURIComponent(return_url));
          } else {
            window.location.replace("/");
          }
        }
      });
    },
    // 服务协议
    onClickServiceAgreement() {
      this.$router.push({
        name: "serviceAgreement"
      })
    },
    // 隐私协议
    onClickPrivacyAgreement() {
      this.$router.push({
        name: "privacyAgreement"
      })
    },
    onClickChildProtection() {
      this.$router.push({
        name: "childProtection"
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/login/login.vue